import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { contractType, contractTypeT } from '../../../common/enums';
import { selectToken } from '../../../features/auth/ducks';
import { signLoanInsuranceActions } from '../ducks';
import { apiCallIds } from '../api';
import { getFileUrl } from '../../../common/utils/helpers';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { translate } from 'react-i18next';
import SignBlock from '../../../features/dashboard/components/registration-action-alert/SignBlock';
import Button from 'antd/lib/button';


const mapStateToProps = state => ({
  token: selectToken(state),
  isLoading: selectIsInProgress(state, apiCallIds.SIGN_LOAN_INSURANCE)
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      signLoanInsurance: signLoanInsuranceActions.request,
    },
    dispatch
  ),
});

@translate()
@connect(mapStateToProps, mapDispatchToProps)
export default class SignLoanInsuranceBlock extends Component {
    static propTypes = {
        isLoading: PropTypes.bool.isRequired,
        actions: PropTypes.object.isRequired,
        loan: PropTypes.object,
        token: PropTypes.string.isRequired,
        t: PropTypes.func.isRequired,
    };

    state = {
        checked: false
    }
    
    handleSubmit = () => {
        const { actions, loan } = this.props;
        actions.signLoanInsurance({ loanId: loan.id });
    };

    onChecked = (val) => {
        this.setState({ checked: val });
    }
    
    render() {
        const { isLoading, token, loan, t } = this.props;
    
        if (!loan) {
            return null;
        }
        const insuranceContract = loan.contracts.find(c => c.type === contractType.INSURANCE_CONTRACT);
    
        let fileLocation = null;
        if (insuranceContract) {
            fileLocation = getFileUrl(insuranceContract.fileId, token)
        }
    
        if (!insuranceContract) {
            return null;
        }

        let modalText = t(
            'Dlžník sa oboznámil so znením Zmluvy o poistení (zmluva medzi Vami a prevádzkovateľom portálu Majak.sk, spoločnosť Peer2Peer, s.r.o.), rozumie jej, súhlasí s jej znením a berie na vedomie všetky jej účinky ako aj všetky práva a povinnosti z nej vyplývajúce. Je si vedomý, že kliknutím na tlačidlo “Potvrdiť Zmluvu o poistení” je táto zmluva pre dlžníka v celom svojom rozsahu záväzná.'
        )
        
        let checkBoxText = t('Súhlasím so Zmluvou o poistení')
        let buttonText = t('Potvrdiť Zmluvu o positení')
        
        return (
            <div>
                <SignBlock
                    isLoading={isLoading}
                    fileLocation={fileLocation}
                    onChecked={(val) => this.onChecked(val)}
                    title={contractTypeT.INSURANCE_CONTRACT}
                    text={modalText}
                    checkboxText={checkBoxText}
                    fileLinktext={t('Prečítať zmluvu')}
                    buttonText={buttonText}
                    isChecked={this.state.checked}
                />
                <div className='ant-modal-footer'>
                    <Button
                        size="small"
                        type="primary"
                        loading={isLoading}
                        onClick={this.handleSubmit}
                        disabled={!this.state.checked}
                    >
                    { t('Potvrdiť zmluvu') }
                    </Button>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/features/loans/components/SignLoanInsuranceBlock.js